import { useEffect, useState } from "react";

import { loadCharacterAvatarSource } from "../clients/characterAvatar.client";

export function useCharacterAvatarSource(avatarUrl, token) {
  const [source, setSource] = useState(
    avatarUrl?.startsWith("/characters/") ? "" : avatarUrl || ""
  );

  useEffect(() => {
    let cancelled = false;
    const isStoredAvatar = avatarUrl?.startsWith("/characters/");
    setSource(isStoredAvatar ? "" : avatarUrl || "");

    if (!isStoredAvatar) {
      return () => {
        cancelled = true;
      };
    }

    loadCharacterAvatarSource(avatarUrl, token)
      .then((nextSource) => {
        if (!cancelled) setSource(nextSource);
      })
      .catch(() => {
        if (!cancelled) setSource("");
      });

    return () => {
      cancelled = true;
    };
  }, [avatarUrl, token]);

  return source;
}
